import { ImportCard } from "./Settings.js";

/** 엑셀 이관 (Phase 1-H). 원본 파일은 증적으로 보관하고, 불일치 0 이 될 때까지 완료로 보지 않는다 */
export function ImportExcel() {
  return (
    <>
      <div className="admin-head">
        <span className="navicon" aria-hidden="true">⇪</span>
        <div>
          <h1>엑셀 이관</h1>
          <p className="page-desc" style={{ margin: 0 }}>
            방화벽.xlsx 를 그대로 올립니다. 브라우저가 읽고, 서버가 되읽어 원본과 대조합니다.
          </p>
        </div>
      </div>
      <ImportCard />
    </>
  );
}
